module.exports = __webpack_public_path__ + "fonts/Inter-200-greek32.4a4b49c.woff2";